import React, { useState } from "react";
import { Modal, Container, Row } from "react-bootstrap";
import log from "loglevel";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import paginationFactory from "react-bootstrap-table2-paginator";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import { options } from "util/reactTableFuncs";
import { Permission } from "types";
import { Table } from "@avlino-inc/alenza-react";
import styles from "components/dashboard/Dashboard.module.scss";

const PermissionsCard = ({ permissions }: { permissions: Permission[] }) => {
  const [selectedPermission, setSelectedPermission] = useState<Permission>();
  const [showInfoModal, setShowInfoModal] = useState(false);

  const permissionsTable = (permissions: Permission[]) => {
    const { SearchBar } = Search;
    const columns = [
      {
        dataField: "name",
        text: "Name",
        sort: true,
        headerAlign: "left",
        align: "left"
      }
    ];
    const rowEvents = {
      onClick: (e: any, row: Permission, rowIndex: number) => {
        log.info("Row Index: " + rowIndex);
        log.info("Row: " + JSON.stringify(row));
        setSelectedPermission(row);
        setShowInfoModal(true);
      }
    };
    const dataSorted = permissions.sort((a, b) => a.name.localeCompare(b.name));
    return (
      <>
        <ToolkitProvider
          keyField="id"
          data={dataSorted}
          columns={columns}
          search
        >
          {(props: any) => (
            <div>
              <div className={styles["table__search-container"]}>
                <SearchBar
                  className={styles["table__search-container__search-bar"]}
                  {...props.searchProps}
                />
              </div>
              <div className={Table.classNames.table}>
                <BootstrapTable
                  {...props.baseProps}
                  bordered={false}
                  bootstrap4
                  hover
                  condensed
                  rowEvents={rowEvents}
                  pagination={paginationFactory(options)}
                />
              </div>
            </div>
          )}
        </ToolkitProvider>
      </>
    );
  };

  return (
    <>
      {permissions ? permissionsTable(permissions) : null}
      {/* Permissions Settings Modal */}
      <>
        <Modal
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={showInfoModal}
          onHide={() => {
            setShowInfoModal(false);
          }}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {selectedPermission?.name}{" "}
              <FontAwesomeIcon icon={["far", "info-circle"]} />
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>
              {selectedPermission
                ? selectedPermission.description
                : "Not Available"}
            </p>
          </Modal.Body>
        </Modal>
      </>
    </>
  );
};

export default PermissionsCard;
